const DEFAULT_MIN_SEARCH_LENGTH = 1;

class EmployeeSearchController {

  constructor(DelegationService, EventEmitter) {
    'ngInject';
    this.searchText = '';
    this.filteredEmployees = [];
    this.showList = false;
    this.DelegationService = DelegationService;
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    this.minLengthSearch = this.minLengthSearch || DEFAULT_MIN_SEARCH_LENGTH;
    this.preFiltered = this.preFiltered || false;
    this.onSearch = this.onSearch || this._defaultOnSearch;
  }

  _defaultOnSearch() {
    return {
      then: (f) => {
        f();
      }
    };
  }

  minLengthOfSearchText() {
    return this.searchText.length >= parseInt(this.minLengthSearch);
  }

  hasText() {
    return this.searchText.length >= 1;
  }

  isVisibleList() {
    return this.minLengthOfSearchText() && this.showList && !this.isSearching;
  }

  isVisibleAlertCard() {
    const isEmptyFilteredEmployees = this.filteredEmployees.length === 0;
    return this.showAlertCard && isEmptyFilteredEmployees && this.minLengthOfSearchText() && !this.isSearching;
  }

  cleanSearch() {
    this.searchText = '';
    this.filteredEmployees = [];
    if (this.onCleanSearch) {
      this.onCleanSearch(this.EventEmitter({searchText: this.searchText}));
    }
  }

  search() {
    if (!this.minLengthOfSearchText()) {
      return;
    }

    this._showEmployees();
  }

  _showEmployees() {
    this.isSearching = true;
    this.onSearch(this.EventEmitter({searchText: this.searchText})).then(response => {
      this.employees = response;
      this.filteredEmployees = this._getEmployeesToShow();
      this.showList = this.filteredEmployees.length > 0;
      this.isSearching = false;
      if (this.reportSearchState) {
        this.reportSearchState(this.EventEmitter({searchText:this.searchText , hasResults: this.showList}));
      }
    });
  }

  getProfile(employee) {
    return employee.profile;
  }

  _getEmployeesToShow() {
    return this.employees.filter(({userId, employeeId, name}) => {
      let id = userId || employeeId;
      const searchText = this.searchText.toLowerCase();
      const userIdMatch = id.toLowerCase().indexOf(searchText) > -1;
      const nameMatch = name.toLowerCase().indexOf(searchText) > -1;
      return userIdMatch || nameMatch;
    });
  }

  onSelectEmployeeAndHide({$event: $event}) {
    this.hideList();
    this.onSelectEmployee(this.EventEmitter($event));
    this._updateSelectedEmployee($event.name);
  }

  _updateSelectedEmployee(name) {
    if (this.fixedSelection) {
      this.searchText = name;
      return;
    }

    this.searchText = '';
  }

  hideList() {
    this.showList = false;
  }

}

export default EmployeeSearchController;



// WEBPACK FOOTER //
// ./client/app/components/employeeSearch/employeeSearch.controller.js